import React from "react";
import {
  NodeViewWrapper,
  NodeViewContent,
  type NodeViewProps,
} from "@tiptap/react";

import { cn } from "@/lib/utils";
import type { LayoutVariant } from "./LayoutBlockNode";

export function LayoutBlockComponent({ node }: NodeViewProps) {
  const variant: LayoutVariant =
    (node.attrs.variant as LayoutVariant) ?? "twoColumns";

  if (variant === "card") {
    const cardAlign: "full" | "center" =
      node.attrs.cardAlign === "center" ? "center" : "full";
    const wrapperClass = cn(
      "my-4 rounded-xl border border-slate-200 bg-white/90 px-4 py-4 text-sm leading-relaxed shadow-sm dark:border-slate-700 dark:bg-slate-900/80 overflow-hidden",
      cardAlign === "center" && "max-w-3xl mx-auto",
    );

    return (
      <NodeViewWrapper className={wrapperClass}>
        <NodeViewContent className="space-y-2 text-sm leading-relaxed" />
      </NodeViewWrapper>
    );
  }

  if (variant === "fullWidth") {
    return (
      <NodeViewWrapper className="my-6 rounded-xl border border-amber-200 bg-amber-50/85 px-4 py-4 text-[0.95rem] leading-relaxed shadow-sm dark:border-amber-500/50 dark:bg-amber-900/40">
        <NodeViewContent className="space-y-2" />
      </NodeViewWrapper>
    );
  }

  // twoColumns 默认：编辑态使用多栏布局，桌面上视觉上是两列；
  // 输出 HTML 仍然由 renderHTML 提供基于 grid 的结构。
  return (
    <NodeViewWrapper className="my-4 rounded-xl border border-slate-200 bg-slate-50/80 px-4 py-3 text-sm leading-relaxed shadow-sm dark:border-slate-700 dark:bg-slate-900/70 md:px-5 md:py-4">
      <NodeViewContent className="md:columns-2 md:gap-6" />
    </NodeViewWrapper>
  );
}
